import map from 'lodash/map'
import { BlogStatus } from '@ztechapps/blog.common'

export const blogStatusOptions = map(BlogStatus, (item) => {
  return { label: item.value, value: item.value }
})
